@use '../../styles/agent' as agent;
@use '../../styles/tokens' as *;

.pillPopoverTarget {
  display: flex !important; // Blueprint's inline-block target span doesn't center in the nav row
  align-items: center;
}

.pill {
  @include agent.agentPillButton;
  margin: 0 $appNavHeadingMargin;
}

.sparkle {
  @include agent.agentSparkleStagger;
}

.popoverBody {
  display: flex;
  flex-direction: column;
  gap: $space0_75;
  padding: $space1;
  width: 32rem;
}

.popoverTitle {
  font-weight: 600;
}

.runCard {
  display: flex;
  align-items: center;
  gap: $space0_75;
}

.runInfo {
  flex: 1;
  min-width: 0;
}

.runTitle {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.runMeta {
  color: $colorDarkestGray;
  font-size: 1.2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.statusTag {
  flex-shrink: 0;
}
